import Vue from 'vue'
import Notify from '../mixins/notify'

Object.defineProperty(Vue.prototype, '$notify', { value: Notify });
